import http from "./http";

const register = (deviceToken, platform) => {
  return http.post("/devices", { device_token: deviceToken, platform });
};

const unregister = (deviceToken) => {
  // FCM tokens can contain ':' - encode for the path segment
  return http.delete(`/devices/${encodeURIComponent(deviceToken)}`);
};

export const DeviceService = {
  register,
  unregister,
};
